import { format } from 'date-fns';
import { Case } from '../../casescontext/domain/case';

export const SAISINE_CAP = 5000;
export const SAISINE_WINDOW_DAYS = 30;

export const isPassengerComplete = (passenger) => Boolean(
  passenger
  && passenger.birthDate
  && passenger.job
  && passenger.birthPlace
  && passenger.nationality
  && (!passenger.principal || passenger.address),
);

export const isClaimSaisineReady = (claim) => {
  const passengers = claim.passengers || [];
  return passengers.length > 0 && passengers.every(isPassengerComplete);
};

export const flightRangeLabel = (first, last, nbFlights) => {
  if (!first) return null;
  if (!last || first.getTime() === last.getTime()) {
    return `Vol le ${format(first, 'dd/MM/yyyy')}`;
  }
  const suffix = nbFlights ? ` (${nbFlights} vols)` : '';
  return `Vols du ${format(first, 'dd/MM/yyyy')} au ${format(last, 'dd/MM/yyyy')}${suffix}`;
};

export function Saisine({
  _id,
  claims = [],
  jurisdiction,
  airline_name,
  flight_date_min,
  flight_date_max,
  total_compensation = 0,
  computedTotal = 0,
  warnings = [],
  status,
  created_at,
  updated_at,
}) {
  const mappedClaims = claims
    .filter((entry) => entry && entry.claim)
    .map((entry) => ({
      amount: entry.amount,
      claim: Case({ passengers: [], ...entry.claim }),
      generationReady: isClaimSaisineReady(entry.claim),
    }));

  const claimsNotReady = mappedClaims.filter((entry) => !entry.generationReady);

  const flightDates = mappedClaims
    .map((entry) => entry.claim.flight_date)
    .filter(Boolean)
    .map((date) => new Date(date))
    .sort((a, b) => a - b);

  return {
    _id,
    claims: mappedClaims,
    jurisdiction,
    airline_name,
    flight_date_min,
    flight_date_max,
    total_compensation,
    computedTotal,
    warnings,
    status,
    created_at,
    updated_at,
    label() {
      return `${jurisdiction} · ${airline_name}`;
    },
    nbClaims() {
      return mappedClaims.length;
    },
    nbPassengers() {
      return mappedClaims.reduce((sum, entry) => sum
        + entry.claim.passengers.filter((passenger) => passenger.active !== false).length, 0);
    },
    remaining() {
      return Math.max(0, SAISINE_CAP - computedTotal);
    },
    firstFlightDate() {
      return flightDates.length ? flightDates[0] : null;
    },
    lastFlightDate() {
      return flightDates.length ? flightDates[flightDates.length - 1] : null;
    },
    nbFlightDates() {
      return new Set(flightDates.map((date) => date.toDateString())).size;
    },
    flightRange() {
      return flightRangeLabel(this.firstFlightDate(), this.lastFlightDate(), this.nbFlightDates());
    },
    generationReady() {
      return mappedClaims.length > 0 && claimsNotReady.length === 0;
    },
    nbClaimsNotReady() {
      return claimsNotReady.length;
    },
  };
}
